export default __webpack_public_path__ + "static/media/HaloPurp.715a7cac.png";